<template>
  <b-modal
    id="form-line-oa"
    :visible="shallShowLineOaFormModal"
    :title="`${$t('Form')} ${$t('LINE OA')}`"
    footer-class="d-flex justify-content-between"
    size="lg"
    centered
    no-close-on-backdrop
    @change="(val) => $emit('update:shall-show-line-oa-form-modal', val)"
  >
    <!-- Modal Header -->
    <template #modal-header>
      <h5 class="modal-title">
        {{ `${$t(typeLineOaForm)} ${$t('LINE OA')}` }}
      </h5>
      <div class="modal-actions">
        <feather-icon
          icon="MinusIcon"
          class="cursor-pointer"
          @click="(busy === false) ? $emit('update:shall-show-line-oa-form-modal', false) : false"
        />
        <!-- <feather-icon
          icon="Maximize2Icon"
          class="ml-1 cursor-pointer"
        /> -->
        <feather-icon
          icon="XIcon"
          class="ml-1 cursor-pointer"
          @click="(busy === false) ? onDiscard() : false"
        />
      </div>
    </template>

    <!-- Modal Footer -->
    <template #modal-footer>
      <!-- Footer: Left Content -->
      <div>
        <b-button
          v-if="(typeLineOaForm !== 'View')"
          ref="submit"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          right
          :disabled="busy"
          @click="onSubmit"
        >
          {{ (typeLineOaForm === 'Add' || typeLineOaForm === 'Edit') ? $t('Save Data') : $t('Delete Data') }}
        </b-button>
      </div>

      <!-- Footer: Right Content -->
      <div>
        <!-- Discard -->
        <feather-icon
          icon="XCircleIcon"
          size="17"
          class="ml-75 cursor-pointer"
          @click="(busy === false) ? onDiscard() : false"
        />
      </div>
    </template>

    <!-- Modal: Body -->
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <div>
        <b-form
          ref="refForm"
          class="position-relative"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <div>
            <b-card style="margin-bottom: 0.6rem;">
              <div>
                <b-row>
                  <!-- Field: Name -->
                  <b-col
                    cols="6"
                  >
                    <b-form-group
                      v-if="(typeLineOaForm === 'Add' || typeLineOaForm === 'Edit')"
                      :label="`${$t('Name')} ${$t('LINE OA')}`"
                      label-for="line-oa-name"
                    >
                      <validation-provider
                        #default="validationContext"
                        :name="`${$t('Name')} ${$t('LINE OA')}`"
                        rules="required"
                      >
                        <b-form-input
                          id="line-oa-name"
                          v-model="lineOaData.name"
                          :state="getValidationState(validationContext)"
                          :disabled="busy"
                        />
                        <small class="text-danger">{{ validationContext.errors[0] }}</small>
                      </validation-provider>

                    </b-form-group>

                    <b-form-group
                      v-else
                      :label="`${$t('Name')} ${$t('LINE OA')}`"
                      label-for="line-oa-name"
                    >
                      <span class="form-info-box">{{ lineOaData.name }}</span>
                    </b-form-group>
                  </b-col>
                  <!-- Field: Channel ID -->
                  <b-col
                    cols="6"
                  >
                    <b-form-group
                      v-if="(typeLineOaForm === 'Add' || typeLineOaForm === 'Edit')"
                      :label="$t('Channel ID')"
                      label-for="line-oa-channel-id"
                    >
                      <validation-provider
                        #default="validationContext"
                        :name="$t('Channel ID')"
                        rules="required"
                      >
                        <b-form-input
                          id="line-oa-channel-id"
                          v-model="lineOaData.channel_id"
                          :state="getValidationState(validationContext)"
                          :disabled="busy"
                        />
                        <small class="text-danger">{{ validationContext.errors[0] }}</small>
                      </validation-provider>

                    </b-form-group>

                    <b-form-group
                      v-else
                      :label="$t('Channel ID')"
                      label-for="line-oa-channel-id"
                    >
                      <span class="form-info-box">{{ lineOaData.channel_id }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- Field: Channel Secret -->
                  <b-col
                    cols="12"
                  >
                    <b-form-group
                      v-if="(typeLineOaForm === 'Add' || typeLineOaForm === 'Edit')"
                      :label="$t('Channel Secret')"
                      label-for="line-oa-channel-secret"
                    >
                      <validation-provider
                        #default="validationContext"
                        :name="$t('Channel Secret')"
                        rules="required"
                      >
                        <b-form-input
                          id="line-oa-channel-secret"
                          v-model="lineOaData.channel_secret"
                          :state="getValidationState(validationContext)"
                          :disabled="busy"
                        />
                        <small class="text-danger">{{ validationContext.errors[0] }}</small>
                      </validation-provider>

                    </b-form-group>

                    <b-form-group
                      v-else
                      :label="$t('Channel Secret')"
                      label-for="line-oa-channel-secret"
                    >
                      <span class="form-info-box">{{ lineOaData.channel_secret }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- Field: Channel Access Token -->
                  <b-col
                    cols="12"
                  >
                    <b-form-group
                      v-if="(typeLineOaForm === 'Add' || typeLineOaForm === 'Edit')"
                      :label="$t('Channel Access Token')"
                      label-for="line-oa-channel-access-token"
                    >
                      <validation-provider
                        #default="validationContext"
                        :name="$t('Channel Access Token')"
                        rules="required"
                      >
                        <b-form-textarea
                          id="line-oa-channel-access-token"
                          v-model="lineOaData.channel_access_token"
                          :state="getValidationState(validationContext)"
                          rows="4"
                          :disabled="busy"
                        />
                        <small class="text-danger">{{ validationContext.errors[0] }}</small>
                      </validation-provider>

                    </b-form-group>

                    <b-form-group
                      v-else
                      :label="$t('Channel Access Token')"
                      label-for="line-oa-channel-access-token"
                    >
                      <span class="form-info-box">{{ lineOaData.channel_access_token }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- Field: Key -->
                  <b-col
                    cols="12"
                  >
                    <b-form-group
                      v-if="typeLineOaForm === 'Edit' || typeLineOaForm === 'View'"
                      :label="`${$t('Key')} ${$t('LINE OA')}`"
                      label-for="line-oa-key"
                    >
                      <span class="form-info-box">{{ lineOaData.key }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- Field: Webhook URL -->
                  <b-col
                    cols="12"
                  >
                    <b-form-group
                      v-if="typeLineOaForm === 'Edit' || typeLineOaForm === 'View'"
                      :label="$t('Webhook URL')"
                      label-for="line-oa-webhook-url"
                    >
                      <span class="form-info-box">{{ lineOaData.webhook_url }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </div>

        </b-form>

      </div>

    </validation-observer>

    <b-overlay
      :show="busy"
      no-wrap
      @shown="onShown"
      @hidden="onHidden"
    >
      <template #overlay>
        <div
          v-if="processing"
          class="text-center p-2 bg-primary text-light rounded"
        >
          <feather-icon
            icon="UploadCloudIcon"
            size="20"
          />
          <div class="mb-2">
            {{ `${$t('Processing')}...` }}
          </div>
          <b-progress
            min="1"
            max="10"
            :value="counter"
            variant="success"
            height="6px"
            class="mx-n1"
          />
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <b-card-text
            class="font-weight-bolder"
          >
            {{ $t('Are you sure?') }}
          </b-card-text>
          <div class="d-flex">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mr-3"
              @click="onCancel"
            >
              {{ $t('Cancel') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="outline-success"
              @click="onOK"
            >
              {{ $t('Ok') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton, BForm,
  BFormGroup,
  BRow,
  BCol,
  BCard,
  BOverlay,
  BProgress,
  BCardText,
  BFormInput,
  BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@validations'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { $themeConfig } from '@themeConfig'

export default {
  directives: {
    Ripple,
  },
  components: {
    // BSV
    BButton,
    BForm,
    BFormGroup,
    BOverlay,
    BRow,
    BCol,
    BCard,
    BProgress,
    BCardText,
    BFormInput,
    BFormTextarea,

    ValidationProvider,
    ValidationObserver,
    FeatherIcon,
  },
  model: {
    prop: 'shallShowLineOaFormModal',
    event: 'update:shall-show-line-oa-form-modal',
  },
  props: {
    shallShowLineOaFormModal: {
      type: Boolean,
      required: true,
    },
    typeLineOaForm: {
      type: String,
      default: 'Add',
    },
    lineOaData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      required,
      busy: false,
      processing: false,
      counter: 1,
      interval: null,
      id: this.lineOaData.id,
      userData: JSON.parse(localStorage.getItem(`${$themeConfig.app.commonSession}-user-data`)),
    }
  },
  methods: {
    onShown() {
      // Focus the dialog prompt
      this.$refs.dialog.focus()
    },
    onHidden() {
      // In this case, we return focus to the submit button
      // You may need to alter this based on your application requirements
      this.$refs.submit.focus()
    },
    onSubmit() {
      this.$refs.refFormObserver.validate().then(success => {
        if (success) {
          this.processing = false
          this.busy = true
        }
      })
    },
    onCancel() {
      this.busy = false
    },
    onOK() {
      this.processing = true
      if (this.typeLineOaForm === 'Add') {
        this.lineOaData.user_id = this.userData.id
        store.dispatch('store-line-oa/addLineOa', this.lineOaData)
          .then(response => {
            if (response.status === 200) {
              const okMsg = this.$i18n.t('Process on successfully')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: okMsg,
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                },
              },
              {
                position: 'bottom-right',
              })
              this.busy = false
              this.processing = false

              this.$swal({
                icon: 'success',
                title: this.$i18n.t('Added'),
                text: this.$i18n.t('Your data has been added'),
                timer: 3000,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })

              this.$emit('line-oa-form-update')
              this.$emit('update:shall-show-line-oa-form-modal', false)
            } else {
              const errorMsg = this.$i18n.t('Process on error')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMsg,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
              this.busy = false
              this.processing = false
            }
          })
          .catch(error => {
            const { response, message } = error
            if (response) {
              let errorMsg = this.$i18n.t(response?.data.error)
              if (response.status === 409) {
                errorMsg = `${this.$i18n.t(response?.data.error)}, '${this.$i18n.t('Channel ID')}' ${this.$i18n.t('Duplicate')}`
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMsg,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            } else if (message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error?.message,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            }
            this.busy = false
            this.processing = false
          })
      } else if (this.typeLineOaForm === 'Edit') {
        store.dispatch('store-line-oa/editLineOa', { id: this.lineOaData.id, data: this.lineOaData })
          .then(response => {
            if (response.status === 200) {
              const okMsg = this.$i18n.t('Process on successfully')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: okMsg,
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                },
              },
              {
                position: 'bottom-right',
              })
              this.busy = false
              this.processing = false

              this.$emit('line-oa-form-update')
              this.$emit('update:shall-show-line-oa-form-modal', false)
            } else {
              const errorMsg = this.$i18n.t('Process on error')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMsg,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
              this.busy = false
              this.processing = false
            }
          })
          .catch(error => {
            const { response, message } = error
            if (response) {
              let errorMsg = this.$i18n.t(response?.data.error)
              if (response.status === 409) {
                errorMsg = `${this.$i18n.t(response?.data.error)}, '${this.$i18n.t('Channel ID')}' ${this.$i18n.t('Duplicate')}`
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMsg,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            } else if (message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error?.message,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            }
            this.busy = false
            this.processing = false
          })
      } else if (this.typeLineOaForm === 'Delete') {
        store.dispatch('store-line-oa/deleteLineOa', {
          id: this.lineOaData.id,
        })
          .then(() => {
            const okMsg = this.$i18n.t('Process on successfully')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: okMsg,
                icon: 'CheckCircleIcon',
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            })
            this.busy = false
            this.processing = false

            this.$emit('line-oa-form-update')
            this.$emit('update:shall-show-line-oa-form-modal', false)
          })
          .catch(error => {
            const { response, message } = error
            if (response) {
              const errorMsg = this.$i18n.t(response?.data.error)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMsg,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            } else if (message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error?.message,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              },
              {
                position: 'bottom-right',
              })
            }
            this.busy = false
            this.processing = false
          })
      }
    },
    onDiscard() {
      this.$emit('discard-line-oa-form')
      this.$emit('update:shall-show-line-oa-form-modal', false)
    },
  },
  setup() {
    const {
      refFormObserver,
      getValidationState,
      resetForm,
      clearForm,
    } = formValidation()

    return {
      // Form Validation
      resetForm,
      clearForm,
      refFormObserver,
      getValidationState,
    }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/bootstrap-extended/_variables';
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.modal{
  .line-height-info{
    padding-bottom: 0.6rem;
    &.end{
      padding-bottom: 0;
    }
  }
  .modal-header,
  .modal-header[class*='bg-'] {
    background-color: #fff !important;
  }
  .modal-body {
    background-color: $body-bg !important;
  }
}
.form-info-box{
  display: flex;
  padding: 0.6rem 1rem;
  background-color: #f8f8f8;
  background-clip: padding-box;
  border: 1px solid #f0f0f0;
  border-radius: 0.357rem;
}

.dark-layout {
  .modal{
    .line-height-info{
      padding-bottom: 0.6rem;
      &.end{
        padding-bottom: 0;
      }
    }
    .modal-header,
    .modal-header[class*='bg-'] {
      background-color: $theme-dark-body-bg !important;
    }
    .modal-body {
      background-color: $theme-dark-table-active-bg !important;
    }
  }
  .form-info-box{
    display: flex;
    padding: 0.6rem 1rem;
    background-color: $theme-dark-input-bg;
    background-clip: padding-box;
    border: 1px solid $theme-dark-border-color;
    border-radius: 0.357rem;
  }
}
</style>
